(function () {
    'use strict';

    angular.module('swif.achats')

.factory('QuotationService', ['$q', 'swifFrameworkService', 'AchatsService',
    function ($q, swif, achats) {
        var service = {};
        service.COLLECTION_FIELDS = [];
        service.COLLECTION_ID = 'quotations';
        service.getCollection = function () {
            return swif.collection.getCollection(service.COLLECTION_ID);
        };

        service.createCollection = function () {
            var filter = {};
            filter.fields = service.COLLECTION_FIELDS;
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.COLLECTION_ID,
                'quotation',
                filter,
                {location: true}
            );
        };

        service.initializeModel = function (quotation) {
            // create 'offer_ids' one2many field (for save/create purpose)
            _.forEach(quotation.suppliers, function (supplier) {
                supplier.offer_ids = _.pluck(supplier.offers, 'id');
            });
        };

        service.sanitizeModel = function (quotation) {
            function sanitizeProducts (item) {
                item.description = item.dqe || '';
                item.product_id = achats.formatters.m2o(item.product_id);
                return item;
            }
            function sanitizeSuppliers (item) {
                function sanitizeOffers (offer) {
                    var taxIds = offer.tax.id ? [offer.tax.id]: [];
                    return {
                        name: offer.name,
                        product_id: achats.formatters.m2o(offer.product_id),
                        product_qty: offer.product_qty,
                        product_price: offer.product_price,
                        product: offer.product,
                        discount: offer.discount,
                        selected: offer.selected,
                        taxe_ids: [[6, 0, taxIds]],
                        selected_product: offer.selected_product,
                    };
                }
                item.offer_ids = swif.data.prepareOne2manyValues(
                    item.offer_ids,
                    item.offers,
                    sanitizeOffers
                );
                item.partner_id = achats.formatters.m2o(item.partner_id);
                item.partner_address_id = achats.formatters.m2o(item.partner_address_id);
                delete item._amount;
                delete item.po_ask_id;
                delete item._offers;
                delete item._email;
                return item;
            }
            // prepare model (compute onemany data, remove fake fields, etc...)
            // then, save the model to the backend
            quotation.order_lines = swif.data.prepareOne2manyValues(
                quotation.order_lines || [],
                quotation.products,
                sanitizeProducts
            );
            quotation.suppliers_id = swif.data.prepareOne2manyValues(
                quotation.suppliers_id || [],
                quotation.suppliers,
                sanitizeSuppliers
            );
            return quotation;
        };

        service.sanitizeModelForEmail = function (quotation) {
            var ret = {suppliers_id: [], id: quotation.id};
            _.forEach(quotation.suppliers, function (supplier) {
                if (supplier.id) {
                    var val = {
                        send_email: supplier.send_email,
                        sent: supplier.sent,
                        date_sent: supplier.date_sent
                    };
                    ret.suppliers_id.push([1, supplier.id, val]);
                }
            }); return ret;
        };

        service.save = function (quotation) {
            quotation = service.sanitizeModel(quotation);
            var ret;
            if (quotation.id) {
                ret = swif.data.save('quotation', quotation.id, quotation);
            } else {
                ret = swif.data.create('quotation', quotation);
            }
            return ret;
        };

        service.saveForEmail = function (quotation) {
            quotation = service.sanitizeModelForEmail(quotation);
            return swif.data.save('quotation', quotation.id, quotation);
        };

        service.makePurchase = function (quotation) {
            return swif.data.callKw(
                'quotation',
                'to_draft_po',
                [[quotation.id]]
            );
        };

        service.resolveData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createCollection());
                $q.all(defers).then(function (res) {
                    var data = {quotations: res[0]};
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service._buildVariantKey = function (id, is_stock, name) {
            var key = id;
            if (!is_stock) {
                key += '|' + name;
            }
            return key;
        }

        service.buildVariantKeyFromProduct = function (product) {
            return service._buildVariantKey(product.id, product.is_stock, product.name);
        }

        service.buildVariantKeyFromLine = function (line) {
            return service._buildVariantKey(line.product_id[0], line.is_stock, line.dqe);
        }

        service.buildVariantKeyFromOffer = function (offer) {
            return service._buildVariantKey(offer.product_id[0], offer.product_is_stock, offer.name);
        }

        service.addProductVariantMetadata = function(product) {
            // @FIXME - clearly, there is a bad design here! We got a product
            // in parameter, and reload it to retrieve more data field... Hueh?
            // Yes, "is_stock" field should be retrieve with the first fetch, not here...
            var ret = $q.defer();

            var filter = {fields: ["is_stock"]};
            swif.data.addFilter(filter, 'id', '=', product.product_id[0]);
            swif.data.get('product', undefined, filter).then(elt => {
                product.is_stock = elt[0].is_stock;
                product.variant_key = service.buildVariantKeyFromLine(product);
                ret.resolve(product);
            });

            return ret.promise;
        }

        service.addOfferVariantMetadata = function(offer) {
            // @FIXME - same as .addProductVariantMetadata()
            var ret = $q.defer();

            var filter = {fields: ["is_stock"]};
            swif.data.addFilter(filter, 'id', '=', offer.product_id[0]);
            swif.data.get('product', undefined, filter).then(product => {

                offer.product_is_stock = product[0].is_stock;
                offer.variant_key = service.buildVariantKeyFromOffer(offer);
                ret.resolve(offer);
            });

            return ret.promise;
        }

        service.buildOfferFromProduct = function(product) {
            var ret = $q.defer();

            var offer = {
                name: product.dqe,
                product_id: product.product_id,
                product_qty: product.qty,
                product_price: 0.0,
                product: product.id || product.fake_id,
                discount: 0.0,
                tax: achats.tax.getDefault(achats.tax.lastData) || {}
            };
            service.addOfferVariantMetadata(offer).then(elt => {
                ret.resolve(elt);
            });

            return ret.promise;
        }

        service.buildLineFromProduct = function (model, product) {
            var ret = $q.defer();

            // TG 3332 - Compute display's order for the offer of a supplier
            // search all "fake_id" on model.products that an't undefined
            var fake_ids = _.pluck(model.products, 'fake_id').filter(fake_id => fake_id !== undefined);
            // search all "id" on model.products that an't undefined
            var products_ids = _.pluck(model.products, 'id').filter(products_id => products_id !== undefined);
            // Compute fake_id, depending on other products
            var fake_id = 0;
            if(model.products.length !== 0){
                if (fake_ids.length !== 0) {
                    fake_id = Math.max(...fake_ids) + 1;
                } else if (products_ids.length !== 0) {
                    fake_id = Math.max(...products_ids) + 1;
                }
            }

            var item = {
                product_id: [product.id, product.complete_name || product.name],
                qty: 1,
                dqe: product.name,
                fake_id: fake_id
            };

            // Depending on where we come from, we may execute the call twice...
            // We don't deals with it here for the sake of visibility
            service.addProductVariantMetadata(item).then(function (elt) {
                ret.resolve(elt);
            });

            return ret.promise;
        };

        service.initializeFromConsumables = function (model) {
            achats.product.fetchFromConsumablesCart()
            .then(function (products) {
                achats.tax.fetchChoices().then(function () {
                    // finally, add a quotation line for each product
                    _.forEach(products, function (product) {
                        service.buildLineFromProduct(model, product).then(function (item) {
                            model.products.push(item);
                        });
                    });
                });
            });
        };

        /**
         * Just because we don't know how to fetch these metadata while fetching
         * the instances themself, we append them later, just before using them :/
         */
        service.updateVariantMetadata = function (model) {
            var ret = $q.defer();
            var defers = [];

            angular.forEach(model.products, function (product) {
                defers.push(service.addProductVariantMetadata(product));
            });
            angular.forEach(model.suppliers, function (supplier) {
                angular.forEach(supplier.offers, function (offer) {
                    defers.push(service.addOfferVariantMetadata(offer));
                });
            });

            $q.all(defers).then(function (res) {
                ret.resolve();
            });

            return ret.promise;
        }
        service.computeOfferAmount = function (offer) {
            // if tax already includes price, the VAT included price does not change
            var tax = offer.tax.price_include ? 1.0  : 1.0 + (offer.tax.amount || 0);
            offer._amount = offer.product_price * tax * offer.product_qty * (1.0 - offer.discount / 100.0);

        };

        // computeOffers() is called at any change on offers or products,
        // must be as fast as possible
        service.computeOffers = function (supplier) {
            supplier._offers = {};

            var totalAmount = 0.0;
            angular.forEach(supplier.offers || [], function (item) {
                service.computeOfferAmount(item);
                item._tax = item.tax.id ? [item.tax.id, achats.tax.format(item.tax)] : false;
                supplier._offers[item.variant_key] = item;
                totalAmount += item._amount || 0.0;
            });
            supplier._amount = supplier.selected ? totalAmount : 0;

            supplier._totalTTC = totalAmount;
        };


        /**
         * Remove temporary renamed variant... No better tips founded :/
         * i.e: when the end-user edit the product name (line.qde), we
         * delete the previous variant to create a new one
         */
        service._cleanupSupplierOfferVariant = function (model, supplier) {
            var offers = angular.copy(supplier.offers);

            angular.forEach(offers, function (product, i) {
                var found = _.find(model.products, function (elt) {
                    return product.variant_key == elt.variant_key;
                });
                if (!found) {
                    supplier.offers.splice(i, 1);
                }
            });
        }

        service._ensureSupplierHasProduct = function (supplier, product) {
            var ret = $q.defer();

            var offer = _.find(supplier.offers, function (elt) {
                return product.variant_key == elt.variant_key;
            });

            if (offer) {
                offer.product_qty = product.qty;
                offer.name = product.dqe;
                ret.resolve(offer);
            } else {
                service.buildOfferFromProduct(product).then(offer => {
                    supplier.offers.push(offer);
                    ret.resolve(offer);
                });
            }

            return ret.promise;
        };

        service.ensureSupplierHasNotProduct = function (supplier, product) {
            var found = _.remove(supplier.offers, function (elt) {
                return product.variant_key == elt.variant_key;
            });
        };

        service._updateSupplierOfferWithVariants = function (model, supplier, product) {
            service._cleanupSupplierOfferVariant(model, supplier);
            return service._ensureSupplierHasProduct(supplier, product);
        };

        //moved into quotation (or purchase_order_ask) service, to be able to use it into task service
        service.onChangeProduct = function (model, line) {
            var ret = $q.defer();
            // Update the variant key first !
            line.variant_key = service.buildVariantKeyFromLine(line);

            var defers = [];
            _.forEach(model.suppliers, function (supplier) {
                var callback = service._updateSupplierOfferWithVariants(model, supplier, line).then(function() {
                    service.computeOffers(supplier);
                });
                defers.push(callback);
            });

            $q.all(defers).then(function() {
                ret.resolve();
            });

            return ret.promise;
        };

        service.addProductInPOAsk = function (model, product) {
            if (!product.id) {  // How could we get product without ID??
                return;
            }
            product.variant_key = service.buildVariantKeyFromProduct(product);

            var item = _.find(model.products, function (elt) {
                return elt.variant_key == product.variant_key;
            });

            // Update product (or variant)
            if (item) {
                item.qty += 1;
                service.onChangeProduct(model, item);  // Also update suppliers offers quantity
            } else {
                // Add new or variant products
                service.buildLineFromProduct(model, product).then(item => {
                    model.products.push(item);
                    service.onChangeProduct(model, item);  // Also add new product to suppliers offers
                });
            }
        };

        service.preModal = function (data) {
            var ret = service.getCollection().preModal(data);
            if(data.action.id === 'add') {
                data.model._type = 'quotation';
                data.model.suppliers = [];
                data.model.products = [];
                service.initializeFromConsumables(data.model);
            }
            return ret;
        };

        service.preValidate = function (data) {
            var ret = true;
            if (_.contains(['add', 'edit', 'manage_offers',], data.action.id)) {
                ret = service.save(data.model);
            } else if (_.contains(['email_suppliers', 're_email_suppliers'], data.action.id)) {
                ret = service.saveForEmail(data.model);
            } else if (data.action.id === 'make_purchase') {
                data.model.state = 'ordered';
                ret = service.makePurchase(data.model);
            }
             else {
                ret = service.getCollection().preValidate(data);
            }
            return ret;
        };

        service.callback = function (error, data) {
            if (data.action.id === 'add') {
                // TODO: could not use fasterCallback (for now),
                // data.result is not defiend here (perharps because modal.http is not defined)
                service.getCollection().getItems();
                swif.collection.defaultCallbackMessage(error, data);
            }
            else if (_.contains(swif.collection.defaultActionIds, data.action.id)) {
                service.getCollection().fasterCallback(data);
            }
            else {
                service.getCollection().updateItem(data.model);
            }
        };

        service.getFilters = function (quotation) {
            var ret = {
                supplier: {},
                product: {}
            };
            swif.data.addFilter(ret.supplier, 'type_id.product_supplier', '=', true);
            // TOCHECK: should we use 'purchase_ok' instead ?
            achats.filters.getProductFilter(ret.product);
            return ret;
        };

        service.getCountFilter = function () {
            var ret = {
                info: {},
                success: {}
            };
            swif.data.addFilter(ret.info, 'state', '=', 'sent');
            swif.data.addFilter(ret.success, 'state', '=', 'priced');
            return ret;
        };

        service.suppliers = {};
        service.suppliers.getContactFilter = function (partnerId) {
            var ret = {fields: ['name', 'complete_name', 'email']};
            swif.data.addFilter(ret, 'partner_id', '=', partnerId || 0);
            return ret;
        };
        service.offers = {};

        return service;
    }
])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/achats-stocks/quotations/table_view', {
            templateUrl: 'partials/achats/quotations_table_view.html',
            controller: 'QuotationsController',
            resolve: {
                data: ['QuotationService', function (service) {
                    return service.resolveData();
                }]
            },
            reloadOnSearch: false
        });
        $routeProvider.when('/homepage', {
            templateUrl: 'partials/achats/providers.html',
            controller: 'ProvidersController',
            resolve: {
                data: ['QuotationService', function (service) {
                    return service.resolveData();
                }]
            },
            reloadOnSearch: false
        });
    }])

    .controller('ProvidersController', [
        '$scope', 'swifFrameworkService', 'QuotationService', 'AchatsService', 'data',
        function ($scope, swif, service, achatsSrv, data) {

            // initialize the appropriate data : quotations linked to the right supplier
            function initialize() {
                var quotations = [];
                var user_id = swif.user.getAuthenticatedUserData().contact_id[0];
                angular.forEach (data.quotations.items, function(item) {
                    angular.forEach (item.suppliers, function (supplier) {
                        if (supplier.partner_address_id[0] && supplier.partner_address_id[0] === user_id) {
                            quotations.push(item);
                        }
                    })
                });

                if (quotations[0]) {
                    $scope.isQuotation = true;
                    $scope.quotations = quotations;
                    $scope.selectedQuotation = quotations[0].id;
                    $scope.selectedOffer = quotations[0];
                    $scope.date = quotations[0].date_order;
                    var user_id = swif.user.getAuthenticatedUserData().contact_id[0];
                    angular.forEach (quotations[0].suppliers, function (supplier) {
                        if (supplier.partner_address_id[0] && supplier.partner_address_id[0] === user_id) {
                            $scope.selectedSupplier = supplier;
                            service.computeOffers(supplier);
                        }
                    });
                }
                else {
                    $scope.isQuotation = false;
                }
            }

            initialize();

            $scope.onChangeOffer = function (supplier) {
                service.computeOffers(supplier);
            };

            $scope.onChangeTax = function (supplier, offer, tax) {
                offer.tax = tax;
                service.computeOffers(supplier);
            };

            $scope.choices = {
                taxes: []
            };

            achatsSrv.tax.fetchChoices().then(function (data) {
                $scope.choices.taxes = data;
            });

            // display the offer's quotation
            $scope.onClickQuotationProvider = function (quotation) {
                $scope.selectedOffer = quotation;
                var user_id = swif.user.getAuthenticatedUserData().contact_id[0];
                angular.forEach (quotation.suppliers, function (supplier) {
                    if (supplier.partner_address_id === user_id || supplier.partner_address_id[0] === user_id) {
                        $scope.selectedSupplier = supplier;
                        service.computeOffers(supplier);
                    }
                });
                $scope.date = quotation.date_order;
                $scope.selectedQuotation = quotation.id;
            }

            // set a line of product on or off according to the supplier's will
            $scope.ignoreProductLine = function (currentOffer, quotation) {
                if (currentOffer.selected_product === false) {
                    currentOffer.disabled = true;
                    currentOffer.product_price = 0;
                    currentOffer._tax = 0;
                    currentOffer.discount = 0;
                    quotation._totalTTC = quotation._totalTTC - currentOffer._amount;
                    currentOffer._amount = 0;
                }
                else if (currentOffer.selected_product === true) {
                    currentOffer.disabled = false;
                }
            }

            $scope.sendOffer = function (quotation) {
                var user_id = swif.user.getAuthenticatedUserData().contact_id[0];
                angular.forEach (quotation.suppliers, function (supplier) {
                    if (supplier.partner_address_id === user_id || supplier.partner_address_id[0] === user_id) {
                        supplier.offer_sent = true;
                        quotation = service.sanitizeModel(quotation);

                        var ret;
                        ret = swif.data.save('quotation', quotation.id, quotation);
                        return ret;
                    }
                });
            }
        }
    ])

    .controller('QuotationsController', [
        '$scope', 'swifFrameworkService', 'data', 'QuotationService', 'AchatsService',
        function ($scope, swif, data, service, achats) {
            function doActionRead (quotation) {
                var action = swif.action.getActionById('quotation', 'misc', 'read', quotation);
                if (action) {
                    swif.action.dispatch('quotation', action, quotation, {});
                }
                // avoid tr to be de-selected (collection directive)
                if (event) {
                    event.stopPropagation();
                }
            }

            function doAction (category, actionId, quotation) {
                var action = swif.action.getActionById('quotation', category, actionId, quotation);
                if (action) {
                    swif.action.dispatch('quotation', action, quotation, {
                        preModal: $scope.preModal,
                        preValidate: $scope.preValidate,
                        callback: $scope.callback
                    });
                }
                return action;
            }

            function initialize () {
                $scope.quotations = data.quotations;
                $scope.preModal = service.preModal;
                $scope.preValidate = service.preValidate;
                $scope.callback = service.callback;
                $scope.countFilter = service.getCountFilter();
                var action = achats.product.parseLocationForAction();
                if (action.actionId) {
                    doAction(action.category, action.actionId, {});
                }
            }
            initialize();

            $scope.onClickQuotation = function (quotation) {
                if (!doAction('primary', 'edit', quotation)) {
                    doActionRead(quotation);
                }
            };
        }
    ])


    .controller('QuotationController', [
        '$scope', '$q', '$sce', 'swifFrameworkService', 'QuotationService', 'AchatsService', 'gettextCatalog',
        function ($scope, $q, $sce, swif, service, achatsSrv, gettextCatalog) {

            $scope.translate = {
                'select': gettextCatalog.getString('Select'),
                'unselect': gettextCatalog.getString('Unselect'),
                'noContact': gettextCatalog.getString('No contact')
            }

            function computeSelectedOffers(supplier) {
                var totalAmount = 0;

                angular.forEach(supplier.offers, function(offer) {
                    if (offer.selected || supplier.selected) {
                       totalAmount += offer._amount;
                    }
                });

                supplier._amount = totalAmount;
            }

            $scope.onClickSupplierChoice = function(supplier) {
                if (!supplier.partner_id || Object.keys(supplier._offers).length < supplier.offers.length) {
                    return;
                }

                angular.forEach($scope.model.suppliers, (function(item) {
                    angular.forEach(item._offers, function(offer) {
                        offer.selected=false;
                    });
                    // unselected item only if it's not current one
                    if (item.partner_id && item.partner_id[0] !== supplier.partner_id[0]) {
                        item.selected = false;
                    }
                    // deselect offers already selected
                    angular.forEach(supplier.offers, function(offer) {
                        offer.selected = false;
                    });
                }).bind(this));
                supplier.selected = !supplier.selected;

                angular.forEach($scope.model.suppliers, function(item) {
                    computeSelectedOffers(item);
                });
            };

            function selectProviderIfAllProductsSelected(supplier) {
                var all_prods_are_selected = [];
                angular.forEach(supplier._offers, function(offer){
                    if (offer.selected) {
                        all_prods_are_selected.push(offer.variant_key);
                    } else {
                        all_prods_are_selected.push(false);
                    }
                });
                if (all_prods_are_selected.every(function(val) { return val; })) {
                    supplier.selected = true;
                    angular.forEach(all_prods_are_selected, function(variant_key) {
                        supplier._offers[variant_key].selected = false;
                    });
                };
            };

            $scope.onClickProductChoice = function(product, selected_supplier) {
                if (!selected_supplier.partner_id || !selected_supplier._offers[product.variant_key]) {
                    return;
                }

                angular.forEach($scope.model.suppliers, function(supplier) {
                    // Reset all suppliers, including the current one.
                    supplier.selected = false;

                    // Also reset offer of the supplier, except for the current
                    // one selected.
                    if (supplier.partner_id && (supplier.partner_id[0] != selected_supplier.partner_id[0])) {
                        angular.forEach(supplier._offers, function(offer) {
                            if (offer.variant_key == product.variant_key) {
                                offer.selected = false;
                            }
                        });
                    }

                });

                // Then toogle the offer of the select supplier.
                selected_supplier._offers[product.variant_key].selected = !selected_supplier._offers[product.variant_key].selected;

                selectProviderIfAllProductsSelected(selected_supplier);

                // Finally re-calculate the totals.
                angular.forEach($scope.model.suppliers, function(supplier) {
                    computeSelectedOffers(supplier);
                });

            };

            $scope.setCurrentSupplier = function (supplier) {
                if (!supplier) {
                    supplier = $scope.model.suppliers ? $scope.model.suppliers[0]: false;
                }
                if (supplier) {
                    $scope.selectedSupplier = supplier;
                    if (supplier.partner_id) {
                        $scope.filters.contact =  service.suppliers.getContactFilter(supplier.partner_id[0]);
                    }
                } else {
                    $scope.selectedSupplier = {};
                }
            };
            $scope.onClickSupplier = function (supplier) {
                if (supplier && supplier !== $scope.selectedSupplier) {
                    $scope.setCurrentSupplier(supplier);
                }
            };

            function prepareSupplier (supplier) {
                if (!supplier) {
                    supplier = {};
                }
                if (!supplier.offers) {
                    supplier.offers = [];
                }
                // if an offer is missing a product_id, add it
                var pending_offers = []
                _.forEach($scope.model.products, function (product) {
                    pending_offers.push(service._updateSupplierOfferWithVariants($scope.model, supplier, product));
                });

                Promise.all(pending_offers).then(() => {
                    service.computeOffers(supplier);
                })

                return supplier;
            }

            $scope.addSupplier = function () {
                var item = prepareSupplier();
                $scope.model.suppliers.push(item);
                $scope.setCurrentSupplier(item);
            };

            $scope.onRemoveSupplier = function (supplier) {
                var ret = _.remove($scope.model.suppliers, supplier);
                if (supplier === $scope.selectedSupplier) {
                    $scope.setCurrentSupplier();
                }
            };

            $scope.onChangeOffer = function (supplier, offer) {
            service.computeOffers(supplier);
            };
            $scope.onRemoveOffer = function (supplier, offer) {
                var ret = _.remove(supplier.offers, offer);
                service.computeOffers(supplier);
            };
            $scope.onChangeTax = function (supplier, offer, tax) {
                offer.tax = tax;
                service.computeOffers(supplier);
            };

            $scope.onChangePartner = function (partner) {
                $scope.filters.contact =  service.suppliers.getContactFilter(partner.id);
            };
            $scope.onChangeContact = function (contact) {
                $scope.selectedSupplier._email = contact.email;
            };

            $scope.addFakeProduct = function (model, product) {
                service.addProductInPOAsk(model, product);
                $scope.fakes.product_id = false;
            };

            function onChangeProductQueueProceed() {
                var line = $scope.changeproduct.queue.shift();
                if (!line) {
                    $scope.changeproduct.lock = false;
                    return;
                }

                service.onChangeProduct($scope.model, line).then(function() {
                    onChangeProductQueueProceed();
                });
            }

            $scope.onChangeProductQueue = function (line) {
                $scope.changeproduct.queue.push(line);
                if ($scope.changeproduct.lock) {
                    return;  // The first one which lock it will take care of doing it.
                }
                $scope.changeproduct.lock = true;
                onChangeProductQueueProceed();
            };

            $scope.onRemoveProduct = function (product) {
                var ret = _.remove($scope.model.products, product);
                $scope.fakes.product_id = false;
                // remove product_id on each supplier
                _.forEach($scope.model.suppliers, function (supplier) {
                    service.ensureSupplierHasNotProduct(supplier, product);
                    service.computeOffers(supplier);
                });
            };

            $scope.onChangeNotif = function (state) {
                // pass;
            };

            $scope.formatName = achatsSrv.formatName;

            function initialize () {
                $scope.readonly = $scope.action.id === 'read';
                var manageOffers = $scope.action.id === 'manage_offers';
                $scope.tabs = {offers: Boolean(manageOffers)};
                $scope.accordions = {offers: Boolean(manageOffers)};
                $scope.fakes = {
                    product_id: false
                };
                $scope.filters = service.getFilters($scope.model);
                $scope.filters.product.fields = ['id', 'name', 'complete_name', 'is_stock'];

                /* if (!$scope.model.id && _.isEmpty($scope.model.suppliers)) {
                    var item = {offers: []};
                    $scope.model.suppliers.push(item);
                } */
                if ($scope.model.id) {
                    service.initializeModel($scope.model);
                }

                $scope.setCurrentSupplier();

                $scope.changeproduct = {
                    queue: [],
                    lock: false
                }

                $scope.choices = {
                    taxes: []
                };

                // Only needed when editing the quotation but we MUST be sure
                // metadata variants are added before continue.
                service.updateVariantMetadata($scope.model).then(function () {
                    achatsSrv.tax.fetchChoices().then(function (data) {
                        $scope.choices.taxes = data;
                            _.forEach($scope.model.suppliers, function (item) {
                                service.computeOffers(item);
                                computeSelectedOffers(item);
                            });
                    });
                });
            }
            initialize();
		}
    ]);


})();
